/* FLORASA - Recherche tolerante aux fautes (29 sept. 2026).

   La recherche du header (blocks/ai_gen_block_4968a57.liquid) interroge
   /search/suggest.json a chaque frappe, puis complete avec son propre index
   (fautes d'une lettre, synonymes francais). Deux trous restaient :
     - les lettres inversees (« rnig », « glod », « chian ») : pour la distance
       de Levenshtein du header, c'est deux fautes, donc rien n'est corrige ;
     - Shopify repond en premier, jusqu'a 10 produits, et les corrections du
       header passent APRES : « bague » ramenait les Baguette Studs en tete et
       les bagues derriere, ou pas du tout.

   Ce fichier corrige la requete AVANT qu'elle parte chez Shopify :
   « rnig » -> ring, « bague or » -> ring gold, « neckless » -> necklace. Si la requete
   corrigee ne trouve rien, c'est la reponse a la requete d'origine qui revient.
   Si rien n'est a corriger, la requete part telle quelle.

   Le header n'est pas modifie (255 Ko, trop gros pour etre reecrit sans
   risque) : on se greffe sur fetch(), et seulement sur /search/suggest.json.
   Le vocabulaire vient de l'index que le header garde en sessionStorage
   (fl-index-produits : titres, types, couleurs et matieres), plus une base
   fixe pour les premieres frappes, avant que l'index soit charge. Les tags
   n'y entrent pas : ce sont des cles internes (« price:under-100 ») et
   « peice » devenait « price » au lieu de « piece ». */
(function () {
  'use strict';
  if (window.__flRecherche || !window.fetch || !window.Response || !window.URL) return;
  window.__flRecherche = true;

  /* Francais -> anglais (le catalogue est en anglais). '' = mot vide, retire. */
  var FR = {
    collier: 'necklace', colliers: 'necklaces', sautoir: 'necklace',
    chaine: 'chain', chaines: 'chains',
    bague: 'ring', bagues: 'rings', anneau: 'ring', anneaux: 'rings', chevaliere: 'signet',
    boucle: 'earrings', boucles: 'earrings', oreille: 'earrings', oreilles: 'earrings',
    puce: 'studs', puces: 'studs', clou: 'studs', clous: 'studs', creole: 'hoops', creoles: 'hoops',
    pendentif: 'pendant', pendentifs: 'pendants', medaillon: 'pendant', medaille: 'pendant', breloque: 'charm',
    jonc: 'bangle', joncs: 'bangles', gourmette: 'bracelet', cheville: 'anklet',
    argent: 'silver', argente: 'silver', argentee: 'silver', dore: 'gold', doree: 'gold', jaune: 'gold',
    blanc: 'white', blanche: 'white', noir: 'black', noire: 'black',
    acier: 'steel', inox: 'stainless', inoxydable: 'stainless', laiton: 'brass',
    plaque: 'plated', plaquee: 'plated',
    zircone: 'zircon', zirconium: 'zircon', zirconia: 'zircon', cristal: 'crystal',
    croix: 'cross', crucifix: 'cross', coeur: 'heart', trefle: 'clover', ange: 'angel', anges: 'angel',
    aile: 'wing', ailes: 'wings', etoile: 'star', serpent: 'snake',
    lettre: 'initial', lettres: 'initial', initiale: 'initial', initiales: 'initial',
    personnalise: 'custom', personnalisee: 'custom',
    corde: 'rope', torsade: 'twisted', torsadee: 'twisted', maille: 'link',
    cubain: 'cuban', cubaine: 'cuban',
    homme: 'men', hommes: 'men', femme: 'women', femmes: 'women', unisexe: 'unisex',
    cadeau: 'gift', cadeaux: 'gift',
    de: '', d: '', du: '', des: '', en: '', la: '', le: '', les: '', l: '',
    pour: '', et: '', avec: '', au: '', aux: '', un: '', une: ''
  };
  /* Expressions de deux mots, cherchees en premier (mots vides deja retires). */
  var FR2 = {
    'or rose': 'rose gold', 'or blanc': 'white gold', 'or jaune': 'gold',
    'plaque or': 'gold plated', 'plaquee or': 'gold plated',
    'boucle oreille': 'earrings', 'boucles oreilles': 'earrings',
    'bracelet cheville': 'anklet', 'acier inoxydable': 'stainless steel',
    'argent sterling': 'sterling silver', 'maille cubaine': 'cuban link'
  };
  /* Base fixe : les mots du catalogue qu'un client tape le plus. */
  var BASE = ('ring rings necklace necklaces chain chains bracelet bracelets earring earrings ' +
    'pendant pendants stud studs hoop hoops huggie huggies bangle anklet charm set gold silver ' +
    'sterling rose white plated stainless steel moissanite zircon cross heart clover angel wing ' +
    'jesus piece dog tag tennis cuban rope figaro link miami iced pave baguette solitaire ' +
    'initial letter custom men mens women womens unisex gift twisted polished florasa').split(' ');

  function norm(s) {
    return String(s == null ? '' : s).toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }

  /* Distance de Damerau (variante OSA) bornee : une inversion de deux lettres
     voisines compte pour UNE faute (« rnig » -> ring). On s'arrete des que la
     distance depasse le maximum tolere. */
  function dist(a, b, max) {
    if (a === b) return 0;
    var la = a.length, lb = b.length, i, j;
    if (Math.abs(la - lb) > max) return max + 1;
    var d2 = [], d1 = [], d0 = [];
    for (j = 0; j <= lb; j++) d1[j] = j;
    for (i = 1; i <= la; i++) {
      d0 = [i];
      var mini = i;
      for (j = 1; j <= lb; j++) {
        var cout = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        var v = Math.min(d0[j - 1] + 1, d1[j] + 1, d1[j - 1] + cout);
        if (i > 1 && j > 1 && a.charCodeAt(i - 1) === b.charCodeAt(j - 2) && a.charCodeAt(i - 2) === b.charCodeAt(j - 1)) {
          v = Math.min(v, d2[j - 2] + 1);
        }
        d0[j] = v;
        if (v < mini) mini = v;
      }
      if (mini > max) return max + 1;
      d2 = d1; d1 = d0;
    }
    return d1[lb];
  }

  /* Squelette phonetique : premiere lettre + consonnes, sans doublons.
     « neckless » et « necklace » donnent tous deux « nkls ». Sert de dernier recours
     quand la faute depasse ce que la distance tolere. Le h de th, sh, ch
     compte : sans lui « leather » et « letter » avaient le meme squelette. */
  function squelette(m) {
    var s = m.replace(/ph/g, 'f').replace(/ck/g, 'k').replace(/c(?=[eiy])/g, 's')
      .replace(/[cq]/g, 'k').replace(/z/g, 's').replace(/x/g, 'ks')
      .replace(/([^aeiouy])h/g, '$1#');
    return (s.charAt(0) + s.slice(1).replace(/[aeiouyhw]/g, '')).replace(/(.)\1+/g, '$1');
  }

  var vocab = null, vocabBrut = null;
  function vocabulaire() {
    var brut = null;
    try { brut = sessionStorage.getItem('fl-index-produits'); } catch (e) {}
    if (vocab && brut === vocabBrut) return vocab;
    var f = Object.create(null);
    BASE.forEach(function (m) { f[m] = 1; });
    /* poids : un mot de titre compte plus qu'un type, un type plus qu'une option */
    try {
      var c = brut && JSON.parse(brut);
      ((c && c.i) || []).forEach(function (e) {
        [[e.nTitre, 3], [e.nType, 2], [e.nOpts, 1]].forEach(function (champ) {
          String(champ[0] || '').split(' ').forEach(function (m) {
            if (m.length > 2 && !/\d/.test(m)) f[m] = (f[m] || 0) + champ[1];
          });
        });
      });
    } catch (e) {}
    vocab = { f: f, mots: Object.keys(f) };
    vocabBrut = brut;
    return vocab;
  }

  /* deux lettres voisines inversees, et rien d'autre (« peice » / « piece ») */
  function inversion(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length - 1; i++) {
      if (a.charAt(i) !== b.charAt(i)) {
        return a.charAt(i) === b.charAt(i + 1) && a.charAt(i + 1) === b.charAt(i) && a.slice(i + 2) === b.slice(i + 2);
      }
    }
    return false;
  }

  /* Touches voisines sur un clavier QWERTY (diagonales comprises). */
  var CLAVIER = {
    q: 'wa', w: 'qase', e: 'wsdr', r: 'edft', t: 'rfgy', y: 'tghu', u: 'yhji', i: 'ujko', o: 'iklp', p: 'ol',
    a: 'qwsz', s: 'awedxz', d: 'serfcx', f: 'drtgvc', g: 'ftyhbv', h: 'gyujnb', j: 'huikmn', k: 'jiolm', l: 'kop',
    z: 'asx', x: 'zsdc', c: 'xdfv', v: 'cfgb', b: 'vghn', n: 'bhjm', m: 'njk'
  };
  function voisines(a, b) { return !!(a && b && CLAVIER[a] && CLAVIER[a].indexOf(b) !== -1); }

  /* Un mot court est souvent un vrai mot anglais a une lettre d'un mot du
     catalogue (« wine » / wing, « block » / black, « cover » / clover). Sur 5
     lettres ou moins, on n'accepte donc que les fautes de frappe typiques :
     deux lettres inversees (« rnig »), une touche voisine (« rimg »), une
     lettre doublee en trop ou en moins (« studd », « tenis »). m et w sont a
     distance 1. */
  function fauteDeFrappe(m, w) {
    var i = 0;
    while (i < m.length && m.charAt(i) === w.charAt(i)) i++;
    if (m.length === w.length) {
      return inversion(m, w) || (m.slice(i + 1) === w.slice(i + 1) && voisines(m.charAt(i), w.charAt(i)));
    }
    if (m.length > w.length) {
      var x = m.charAt(i);
      return x === m.charAt(i - 1) || x === m.charAt(i + 1) || voisines(x, m.charAt(i - 1)) || voisines(x, m.charAt(i + 1));
    }
    var y = w.charAt(i);
    return y === w.charAt(i - 1) || y === w.charAt(i + 1);
  }

  /* a < b, cle par cle (tableaux de meme longueur) */
  function avant(a, b) {
    for (var k = 0; k < a.length; k++) if (a[k] !== b[k]) return a[k] < b[k];
    return false;
  }

  /* La premiere lettre est presque toujours juste : on ne la change jamais
     (« better » n'est pas letter, « across » n'est pas cross). A distance
     egale, on prefere une inversion (la faute de frappe la plus courante),
     puis le mot le plus present dans le catalogue. */
  function corrigerMot(m, V) {
    if (m.length < 4 || /\d/.test(m) || V.f[m]) return m;
    var i, w;
    /* debut d'un mot connu : le client est en train de le taper */
    for (i = 0; i < V.mots.length; i++) if (V.mots[i].indexOf(m) === 0) return m;
    var max = m.length > 7 ? 2 : 1, best = null, bestCle = null;
    for (i = 0; i < V.mots.length; i++) {
      w = V.mots[i];
      if (w.charAt(0) !== m.charAt(0) || Math.abs(w.length - m.length) > max) continue;
      var d = dist(m, w, max);
      if (d > max || (m.length <= 5 && !fauteDeFrappe(m, w))) continue;
      var cle = [d, inversion(m, w) ? 0 : 1, -V.f[w]];
      if (!bestCle || avant(cle, bestCle)) { best = w; bestCle = cle; }
    }
    if (best) return best;
    /* dernier recours, pour les mots ecrits « au son » : meme squelette de
       consonnes (« neckless » -> necklace), jusqu'a une faute pour deux
       lettres. Il faut au moins 4 consonnes : avec 3, « style » devenait
       steel, « bride » braid, « range » ring. */
    var sq = squelette(m);
    if (sq.length < 4) return m;
    var lim = Math.floor(m.length / 2), bestF = -1;
    for (i = 0; i < V.mots.length; i++) {
      w = V.mots[i];
      if (Math.abs(w.length - m.length) > 2) continue;
      if (squelette(w) !== sq || dist(m, w, lim) > lim) continue;
      if (V.f[w] > bestF) { best = w; bestF = V.f[w]; }
    }
    return best || m;
  }

  /* Requete corrigee, ou null s'il n'y a rien a changer. */
  function corriger(q) {
    var mots = norm(q).split(' ').filter(Boolean);
    if (!mots.length) return null;
    var fr = false, pleins = [], out = [], i;
    for (i = 0; i < mots.length; i++) {
      if (FR[mots[i]] === '') fr = true; else pleins.push(mots[i]);
    }
    for (i = 0; i < pleins.length; i++) {
      var paire = pleins[i] + ' ' + pleins[i + 1];
      if (FR2[paire]) { out.push(FR2[paire]); fr = true; i++; continue; }
      if (FR[pleins[i]]) { out.push(FR[pleins[i]]); fr = true; continue; }
      out.push(pleins[i]);
    }
    /* « or » est aussi un mot anglais : or -> gold seulement s'il est seul ou
       entoure de francais (« bague or », « chaine en or »). */
    var V = vocabulaire();
    out = out.map(function (m) {
      if (m === 'or') return (fr || out.length === 1) ? 'gold' : m;
      return m.indexOf(' ') === -1 ? corrigerMot(m, V) : m;
    });
    var vus = Object.create(null);
    var cq = out.join(' ').split(' ').filter(function (m) {
      if (!m || vus[m]) return false;
      vus[m] = 1; return true;
    }).join(' ');
    return cq && cq !== mots.join(' ') ? cq : null;
  }

  var fetchOrig = window.fetch;
  window.fetch = function (entree, init) {
    var args = arguments;
    try {
      var brute = typeof entree === 'string' ? entree : (entree instanceof URL ? entree.href : null);
      if (brute && brute.indexOf('/search/suggest.json') !== -1 && (!init || !init.method || /^get$/i.test(init.method))) {
        var u = new URL(brute, location.href);
        var cq = u.origin === location.origin && /\/search\/suggest\.json$/.test(u.pathname) ? corriger(u.searchParams.get('q')) : null;
        if (cq) {
          u.searchParams.set('q', cq);
          var origine = function () { return fetchOrig.apply(window, args); };
          return fetchOrig.call(window, u.href, init).then(function (r) {
            if (!r.ok) return origine();
            return r.clone().json().then(function (d) {
              var p = d && d.resources && d.resources.results && d.resources.results.products;
              return p && p.length ? r : origine();
            }, origine);
          }, origine);
        }
      }
    } catch (e) {}
    return fetchOrig.apply(window, args);
  };
  window.flCorrigerRecherche = corriger;
})();
